import { Box, Button, Stack, Typography } from '@mui/material'
import { FC } from 'react'

import { Icon } from '@/components'

type SubscriptionRowProps = {
  id: number
  email: string
  frequency: string
  format: string
  isDelete: boolean
  onDelete: (id: number, email: string) => void
  onReturn: (id: number, email: string) => void
}

export const SubscriptionRow: FC<SubscriptionRowProps> = ({
  id,
  email,
  format,
  frequency,
  isDelete,
  onReturn,
  onDelete,
}) => {
  const getFrequency = (frequency: string) => {
    switch (frequency) {
      case 'DAILY':
        return 'ежедневно'
      case 'MONTHLY':
        return 'ежемесячно'
      default:
        return ''
    }
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '4px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          p: 1.5,
          flex: 1,
          px: 2,
          backgroundColor: 'secondary.main',
          borderRadius: '8px',
          gap: 1,
        }}
      >
        <Stack spacing="4px" direction="column" sx={{ flex: 1 }}>
          <Typography
            variant="body2"
            color="text.primary"
            sx={{
              flex: 1,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              opacity: isDelete ? 0.25 : 1,
            }}
          >
            {email}
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              flex: 1,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              opacity: isDelete ? 0.25 : 1,
            }}
          >
            {`${format} формат, ${getFrequency(frequency)}`}
          </Typography>
        </Stack>
        {!isDelete && (
          <Box
            onClick={() => onDelete(id, email)}
            data-testid="delete-email-button"
            sx={{
              cursor: 'pointer',
            }}
          >
            <Icon name="Cross" size="lg" colorScheme="icons.main" />
          </Box>
        )}
      </Box>
      {isDelete && (
        <Button data-testid="return-email-button" color="secondary" onClick={() => onReturn(id, email)}>
          Вернуть
        </Button>
      )}
    </Box>
  )
}
